// @/services/content/store/modules/self-assessment-bs-elearning.js

export class SelfAssessmentBSELearningHandler {
  constructor(store) {
    this.store = store;
  }

  /**
   * Get Self Assessment Business Segments eLearning content by locale
   * @param {string} locale Locale to get content for
   * @returns {Array|null} Array of content items or null if not found
   */
  getContent(locale = 'en') {
    // Handle collection type - need to return array
    const localeContent = this.store.state.data.selfAssessmentBSELearning?.[locale];
    if (localeContent && Array.isArray(localeContent)) return localeContent;
    
    // Fall back to English if different locale was requested
    if (locale !== 'en') {
      const enContent = this.store.state.data.selfAssessmentBSELearning?.['en'];
      return Array.isArray(enContent) ? enContent : null;
    }
    
    return null;
  }

  /**
   * Get section-specific eLearning content
   * @param {string} sectionId Section identifier (e.g., 'energy-efficiency')
   * @param {string} locale Locale to get content for
   * @returns {Object|null} eLearning content for the section or null if not found
   */
  getSectionELearning(sectionId, locale = 'en') {
    const content = this.getContent(locale);
    
    if (!content) return null;
    
    // More robust matching with normalization
    let match = content.find(item => item.sectionId === sectionId);
    
    if (!match) {
      // Try case-insensitive match
      match = content.find(item => 
        item.sectionId.toLowerCase() === sectionId.toLowerCase()
      );
    }
    
    if (!match) {
      // Try with hyphen/space normalization
      const normalizedSectionId = sectionId.replace(/-/g, ' ').toLowerCase();
      match = content.find(item => {
        const normalizedItemId = item.sectionId.replace(/-/g, ' ').toLowerCase();
        return normalizedItemId === normalizedSectionId;
      });
    }
    
    return match || null;
  }
}